export class AccountPreferencesErrors {
    promienceSubjectNameExists: boolean = false;
    promienceSubjectNameEmpty: boolean = false;
    promienceSubjectKeywordsEmpty: boolean = false;
}
